import React, { useEffect } from "react";
import "../Styles/home.css";

import logo from "../assests/images/app_logo.png";
import LoginORSignUp from "../assests/images/log-in-or-signup.png";
import FindAgentIcon from "../assests/images/findagentIcon.png";
import appStoreLogo from "../assests/images/find-agent.png";
import WhatIsWedluk from "./WhatIsWedluk";
import HowItWorks from "./HowItWorks";
import AgentSection from "./AgentSection";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0); // scroll to top when component mounts
  }, []);

  const handleClick = () => {
    navigate("/loginpage");
  };

  return (
    <div className="home-container-outer">
      <div className="home-container">
        <div className="app_logo">
          <img src={logo} alt="Wedluk Logo" />
        </div>

        <div className="text-content">
          <h1 className="title-text">Welcome to WedLuk</h1>
          <p className="subtitle">The Matrimonial Nexus</p>
          <p className="description">
            Find Love with Confidence, Community‑Driven. Privacy‑First and Built
            for the AI Generation.
          </p>

          <div className="store-buttons">
            <a href="#" onClick={handleClick}>
              <img src={LoginORSignUp} alt="Get it on Google Play" />
            </a>
            <a href="/browseagents"  >
              <img src={FindAgentIcon} alt="Get it on Google Play" />
            </a>
          </div>
        </div>

        <div className="background-pattern">
          <img
            src={require("../assests/images/wed-design.png")}
            alt="Background Pattern"
          />
        </div>
      </div>
      <WhatIsWedluk />
      <HowItWorks />
      <AgentSection />
      <Footer />
    </div>
  );
}
